/* American Threads Co - refresh the header cart (bubble + drawer) after a Teeinblue Add to cart (2026-11-01, SP038).
   Teeinblue adds the line with its own fetch to /cart/add.js and then only fires 'teeinblue-event-after-cart-added'
   on document. This Horizon version updates the cart bubble (assets/cart-icon.js) and the cart drawer only on the
   standard @shopify/events CartLinesUpdateEvent, so after a Teeinblue add the bubble stays at 0 and the drawer says
   "Your cart is empty" until a reload. Here we fetch the fresh cart + the drawer's section HTML and send that event,
   the same way assets/product-form.js and atc-combo-builder.js do. Covers every Teeinblue product (one global file,
   loaded from layout/theme.liquid). No drawer is opened. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* theme ES modules from a classic script: Shopify rewrites dynamic import() in assets, so use an inline module */
  var seq = 0;
  function withModule(spec, cb) {
    var key = '__atcTeeCart' + (++seq);
    window[key] = function (m) { try { delete window[key]; } catch (e) { window[key] = null; } cb(m); };
    var s = document.createElement('script');
    s.type = 'module';
    s.textContent = 'import * as m from ' + JSON.stringify(spec) + '; window[' + JSON.stringify(key) + '](m);';
    document.head.appendChild(s);
  }

  function bubble(count) {
    [].forEach.call(document.querySelectorAll('cart-icon'), function (el) {
      try { if (el.renderCartBubble) el.renderCartBubble(count); } catch (e) {}
    });
  }

  function sync() {
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component'), function (e) {
      if (e.dataset.sectionId && ids.indexOf(e.dataset.sectionId) === -1) ids.push(e.dataset.sectionId);
    });
    var json = function (r) { return r.ok ? r.json() : null; };
    Promise.all([
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(json),
      ids.length ? fetch(location.pathname + '?sections=' + ids.join(','), { headers: { Accept: 'application/json' } }).then(json) : Promise.resolve({})
    ]).then(function (res) {
      var cart = res[0], sections = res[1] || {};
      if (!cart || cart.item_count == null) return;
      bubble(cart.item_count);  /* immediate, even if the module route below fails */
      withModule('@shopify/events', function (m) {
        var E = m.CartLinesUpdateEvent;
        if (!E || !E.createPromise) return;
        var d = E.createPromise();
        document.dispatchEvent(new E({
          action: 'add', context: 'product',
          lines: cart.items.slice(0, 1).map(function (it) { return { merchandiseId: String(it.variant_id), quantity: it.quantity }; }),
          promise: d.promise
        }));
        d.resolve({
          cart: E.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'atc-tee-cart', sourceId: 'atc-tee-cart', itemCount: cart.item_count, sections: sections, didError: false }
        });
      });
    }).catch(function () {});
  }

  document.addEventListener('teeinblue-event-after-cart-added', function () { setTimeout(sync, 300); });
})();
